"use strict";

function cov_k882gzrho() {
  var path = "/mnt/c/Users/lostos/Documents/GitKraken/redux-sounds/src/howler_integration.js";
  var hash = "89b22cd57f8217e10a8afd369fcaa612b942c6f1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/mnt/c/Users/lostos/Documents/GitKraken/redux-sounds/src/howler_integration.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 17
        },
        end: {
          line: 1,
          column: 34
        }
      },
      "1": {
        start: {
          line: 2,
          column: 31
        },
        end: {
          line: 2,
          column: 49
        }
      },
      "2": {
        start: {
          line: 4,
          column: 0
        },
        end: {
          line: 168,
          column: 2
        }
      },
      "3": {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 77
        }
      },
      "4": {
        start: {
          line: 6,
          column: 47
        },
        end: {
          line: 6,
          column: 75
        }
      },
      "5": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 39
        }
      },
      "6": {
        start: {
          line: 13,
          column: 23
        },
        end: {
          line: 13,
          column: 61
        }
      },
      "7": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 49,
          column: 11
        }
      },
      "8": {
        start: {
          line: 15,
          column: 25
        },
        end: {
          line: 15,
          column: 41
        }
      },
      "9": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 20,
          column: 7
        }
      },
      "10": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 47
        }
      },
      "11": {
        start: {
          line: 22,
          column: 22
        },
        end: {
          line: 22,
          column: 41
        }
      },
      "12": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 29,
          column: 7
        }
      },
      "13": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 26,
          column: 11
        }
      },
      "14": {
        start: {
          line: 25,
          column: 10
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "15": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 39
        }
      },
      "16": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 48,
          column: 8
        }
      },
      "17": {
        start: {
          line: 35,
          column: 12
        },
        end: {
          line: 35,
          column: 71
        }
      },
      "18": {
        start: {
          line: 35,
          column: 37
        },
        end: {
          line: 35,
          column: 71
        }
      },
      "19": {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 69
        }
      },
      "20": {
        start: {
          line: 38,
          column: 36
        },
        end: {
          line: 38,
          column: 69
        }
      },
      "21": {
        start: {
          line: 39,
          column: 12
        },
        end: {
          line: 41,
          column: 13
        }
      },
      "22": {
        start: {
          line: 40,
          column: 14
        },
        end: {
          line: 40,
          column: 32
        }
      },
      "23": {
        start: {
          line: 44,
          column: 12
        },
        end: {
          line: 44,
          column: 71
        }
      },
      "24": {
        start: {
          line: 44,
          column: 37
        },
        end: {
          line: 44,
          column: 71
        }
      },
      "25": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 45,
          column: 30
        }
      },
      "26": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 23
        }
      },
      "27": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 77
        }
      },
      "28": {
        start: {
          line: 55,
          column: 42
        },
        end: {
          line: 55,
          column: 77
        }
      },
      "29": {
        start: {
          line: 56,
          column: 23
        },
        end: {
          line: 56,
          column: 61
        }
      },
      "30": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 102,
          column: 20
        }
      },
      "31": {
        start: {
          line: 59,
          column: 25
        },
        end: {
          line: 59,
          column: 41
        }
      },
      "32": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 64,
          column: 7
        }
      },
      "33": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 63,
          column: 47
        }
      },
      "34": {
        start: {
          line: 66,
          column: 22
        },
        end: {
          line: 66,
          column: 41
        }
      },
      "35": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 73,
          column: 7
        }
      },
      "36": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 70,
          column: 11
        }
      },
      "37": {
        start: {
          line: 69,
          column: 10
        },
        end: {
          line: 69,
          column: 54
        }
      },
      "38": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 39
        }
      },
      "39": {
        start: {
          line: 74,
          column: 40
        },
        end: {
          line: 74,
          column: 52
        }
      },
      "40": {
        start: {
          line: 75,
          column: 21
        },
        end: {
          line: 96,
          column: 7
        }
      },
      "41": {
        start: {
          line: 80,
          column: 12
        },
        end: {
          line: 80,
          column: 45
        }
      },
      "42": {
        start: {
          line: 80,
          column: 24
        },
        end: {
          line: 80,
          column: 45
        }
      },
      "43": {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 83,
          column: 43
        }
      },
      "44": {
        start: {
          line: 83,
          column: 23
        },
        end: {
          line: 83,
          column: 43
        }
      },
      "45": {
        start: {
          line: 84,
          column: 12
        },
        end: {
          line: 86,
          column: 13
        }
      },
      "46": {
        start: {
          line: 85,
          column: 14
        },
        end: {
          line: 85,
          column: 32
        }
      },
      "47": {
        start: {
          line: 87,
          column: 12
        },
        end: {
          line: 89,
          column: 13
        }
      },
      "48": {
        start: {
          line: 88,
          column: 14
        },
        end: {
          line: 88,
          column: 39
        }
      },
      "49": {
        start: {
          line: 92,
          column: 12
        },
        end: {
          line: 92,
          column: 35
        }
      },
      "50": {
        start: {
          line: 92,
          column: 24
        },
        end: {
          line: 92,
          column: 35
        }
      },
      "51": {
        start: {
          line: 93,
          column: 12
        },
        end: {
          line: 93,
          column: 30
        }
      },
      "52": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 98,
          column: 33
        }
      },
      "53": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 32
        }
      },
      "54": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 33
        }
      },
      "55": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 20
        }
      },
      "56": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 23
        }
      },
      "57": {
        start: {
          line: 108,
          column: 18
        },
        end: {
          line: 108,
          column: 40
        }
      },
      "58": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 114,
          column: 5
        }
      },
      "59": {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 113,
          column: 7
        }
      },
      "60": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 122,
          column: 5
        }
      },
      "61": {
        start: {
          line: 116,
          column: 27
        },
        end: {
          line: 116,
          column: 64
        }
      },
      "62": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 121,
          column: 7
        }
      },
      "63": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 125,
          column: 5
        }
      },
      "64": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 124,
          column: 46
        }
      },
      "65": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 65
        }
      },
      "66": {
        start: {
          line: 130,
          column: 18
        },
        end: {
          line: 130,
          column: 40
        }
      },
      "67": {
        start: {
          line: 131,
          column: 15
        },
        end: {
          line: 131,
          column: 50
        }
      },
      "68": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 134,
          column: 5
        }
      },
      "69": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 51
        }
      },
      "70": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 14
        }
      },
      "71": {
        start: {
          line: 139,
          column: 23
        },
        end: {
          line: 139,
          column: 56
        }
      },
      "72": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 143,
          column: 6
        }
      },
      "73": {
        start: {
          line: 144,
          column: 19
        },
        end: {
          line: 152,
          column: 5
        }
      },
      "74": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 40
        }
      },
      "75": {
        start: {
          line: 148,
          column: 8
        },
        end: {
          line: 148,
          column: 72
        }
      },
      "76": {
        start: {
          line: 149,
          column: 21
        },
        end: {
          line: 149,
          column: 41
        }
      },
      "77": {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 150,
          column: 40
        }
      },
      "78": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 38
        }
      },
      "79": {
        start: {
          line: 154,
          column: 20
        },
        end: {
          line: 154,
          column: 39
        }
      },
      "80": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 39
        }
      },
      "81": {
        start: {
          line: 159,
          column: 18
        },
        end: {
          line: 159,
          column: 40
        }
      },
      "82": {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 166,
          column: 5
        }
      },
      "83": {
        start: {
          line: 161,
          column: 6
        },
        end: {
          line: 163,
          column: 9
        }
      },
      "84": {
        start: {
          line: 162,
          column: 8
        },
        end: {
          line: 162,
          column: 35
        }
      },
      "85": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 165,
          column: 29
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        },
        loc: {
          start: {
            line: 5,
            column: 15
          },
          end: {
            line: 7,
            column: 3
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 38
          },
          end: {
            line: 6,
            column: 39
          }
        },
        loc: {
          start: {
            line: 6,
            column: 47
          },
          end: {
            line: 6,
            column: 75
          }
        },
        line: 6
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 35
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 14,
            column: 36
          },
          end: {
            line: 14,
            column: 37
          }
        },
        loc: {
          start: {
            line: 14,
            column: 52
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 14
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 24,
            column: 37
          },
          end: {
            line: 24,
            column: 38
          }
        },
        loc: {
          start: {
            line: 24,
            column: 53
          },
          end: {
            line: 26,
            column: 9
          }
        },
        line: 24
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 34,
            column: 18
          },
          end: {
            line: 34,
            column: 19
          }
        },
        loc: {
          start: {
            line: 34,
            column: 26
          },
          end: {
            line: 36,
            column: 11
          }
        },
        line: 34
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 37,
            column: 17
          },
          end: {
            line: 37,
            column: 18
          }
        },
        loc: {
          start: {
            line: 37,
            column: 25
          },
          end: {
            line: 42,
            column: 11
          }
        },
        line: 37
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 43,
            column: 18
          },
          end: {
            line: 43,
            column: 19
          }
        },
        loc: {
          start: {
            line: 43,
            column: 26
          },
          end: {
            line: 46,
            column: 11
          }
        },
        line: 43
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        },
        loc: {
          start: {
            line: 54,
            column: 28
          },
          end: {
            line: 105,
            column: 3
          }
        },
        line: 54
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 58,
            column: 36
          },
          end: {
            line: 58,
            column: 37
          }
        },
        loc: {
          start: {
            line: 58,
            column: 52
          },
          end: {
            line: 102,
            column: 5
          }
        },
        line: 58
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 68,
            column: 37
          },
          end: {
            line: 68,
            column: 38
          }
        },
        loc: {
          start: {
            line: 68,
            column: 53
          },
          end: {
            line: 70,
            column: 9
          }
        },
        line: 68
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 79,
            column: 18
          },
          end: {
            line: 79,
            column: 19
          }
        },
        loc: {
          start: {
            line: 79,
            column: 26
          },
          end: {
            line: 81,
            column: 11
          }
        },
        line: 79
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 82,
            column: 17
          },
          end: {
            line: 82,
            column: 18
          }
        },
        loc: {
          start: {
            line: 82,
            column: 25
          },
          end: {
            line: 90,
            column: 11
          }
        },
        line: 82
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 91,
            column: 18
          },
          end: {
            line: 91,
            column: 19
          }
        },
        loc: {
          start: {
            line: 91,
            column: 26
          },
          end: {
            line: 94,
            column: 11
          }
        },
        line: 91
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 107,
            column: 2
          },
          end: {
            line: 107,
            column: 3
          }
        },
        loc: {
          start: {
            line: 107,
            column: 46
          },
          end: {
            line: 127,
            column: 3
          }
        },
        line: 107
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 129,
            column: 2
          },
          end: {
            line: 129,
            column: 3
          }
        },
        loc: {
          start: {
            line: 129,
            column: 35
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 129
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 138,
            column: 3
          }
        },
        loc: {
          start: {
            line: 138,
            column: 18
          },
          end: {
            line: 156,
            column: 3
          }
        },
        line: 138
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 144,
            column: 19
          },
          end: {
            line: 144,
            column: 20
          }
        },
        loc: {
          start: {
            line: 144,
            column: 31
          },
          end: {
            line: 152,
            column: 5
          }
        },
        line: 144
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 158,
            column: 2
          },
          end: {
            line: 158,
            column: 3
          }
        },
        loc: {
          start: {
            line: 158,
            column: 58
          },
          end: {
            line: 167,
            column: 3
          }
        },
        line: 158
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 161,
            column: 51
          },
          end: {
            line: 161,
            column: 52
          }
        },
        loc: {
          start: {
            line: 161,
            column: 59
          },
          end: {
            line: 163,
            column: 7
          }
        },
        line: 161
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 20,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 20,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 29,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 29,
            column: 7
          }
        }, {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 29,
            column: 7
          }
        }],
        line: 23
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 71
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 38,
            column: 12
          },
          end: {
            line: 38,
            column: 69
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 12
          },
          end: {
            line: 38,
            column: 69
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 38
      },
      "4": {
        loc: {
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 41,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 41,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 39
      },
      "5": {
        loc: {
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 71
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 44
      },
      "6": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 77
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 55
      },
      "7": {
        loc: {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 64,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 64,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 62
      },
      "8": {
        loc: {
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 73,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 73,
            column: 7
          }
        }, {
          start: {
            line: 71,
            column: 13
          },
          end: {
            line: 73,
            column: 7
          }
        }],
        line: 67
      },
      "9": {
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 80,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 80,
            column: 45
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 80
      },
      "10": {
        loc: {
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 83,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 83,
            column: 43
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 83
      },
      "11": {
        loc: {
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 84
      },
      "12": {
        loc: {
          start: {
            line: 87,
            column: 12
          },
          end: {
            line: 89,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 12
          },
          end: {
            line: 89,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 87
      },
      "13": {
        loc: {
          start: {
            line: 87,
            column: 16
          },
          end: {
            line: 87,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 16
          },
          end: {
            line: 87,
            column: 32
          }
        }, {
          start: {
            line: 87,
            column: 36
          },
          end: {
            line: 87,
            column: 56
          }
        }],
        line: 87
      },
      "14": {
        loc: {
          start: {
            line: 92,
            column: 12
          },
          end: {
            line: 92,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 12
          },
          end: {
            line: 92,
            column: 35
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 92
      },
      "15": {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 109
      },
      "16": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 122,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 122,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 115
      },
      "17": {
        loc: {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 18
          }
        }, {
          start: {
            line: 115,
            column: 22
          },
          end: {
            line: 115,
            column: 70
          }
        }],
        line: 115
      },
      "18": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 123
      },
      "19": {
        loc: {
          start: {
            line: 129,
            column: 18
          },
          end: {
            line: 129,
            column: 33
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 129,
            column: 31
          },
          end: {
            line: 129,
            column: 33
          }
        }],
        line: 129
      },
      "20": {
        loc: {
          start: {
            line: 131,
            column: 26
          },
          end: {
            line: 131,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 26
          },
          end: {
            line: 131,
            column: 36
          }
        }, {
          start: {
            line: 131,
            column: 40
          },
          end: {
            line: 131,
            column: 49
          }
        }],
        line: 131
      },
      "21": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 134,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 134,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "22": {
        loc: {
          start: {
            line: 158,
            column: 24
          },
          end: {
            line: 158,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 158,
            column: 37
          },
          end: {
            line: 158,
            column: 39
          }
        }],
        line: 158
      },
      "23": {
        loc: {
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 166,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 166,
            column: 5
          }
        }, {
          start: {
            line: 164,
            column: 11
          },
          end: {
            line: 166,
            column: 5
          }
        }],
        line: 160
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0],
      "23": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "89b22cd57f8217e10a8afd369fcaa612b942c6f1"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_k882gzrho = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_k882gzrho();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref = (cov_k882gzrho().s[0]++, require('howler')),
    Howl = _ref.Howl;

var _ref2 = (cov_k882gzrho().s[1]++, require('./utils')),
    isObjectWithValues = _ref2.isObjectWithValues;

cov_k882gzrho().s[2]++;
module.exports = {
  removeId: function removeId(id) {
    var _this = this;

    cov_k882gzrho().f[0]++;
    cov_k882gzrho().s[3]++;
    Object.keys(this.playing).forEach(function (key) {
      cov_k882gzrho().f[1]++;
      cov_k882gzrho().s[4]++;
      return _this.playing[key]["delete"](id);
    });
  },
  initialize: function initialize(soundsData, dispatch) {
    var _this2 = this;

    cov_k882gzrho().f[2]++;
    cov_k882gzrho().s[5]++;
    // { String: Set[Integer] } Map of currently playing ids for each unique sound name
    // Can also use `new Map()`
    this.playing = Object.create(null);
    var soundNames = (cov_k882gzrho().s[6]++, Object.getOwnPropertyNames(soundsData));
    cov_k882gzrho().s[7]++;
    this.sounds = soundNames.reduce(function (memo, name) {
      cov_k882gzrho().f[3]++;
      var soundOptions = (cov_k882gzrho().s[8]++, soundsData[name]); // Allow strings instead of objects, for when all that is needed is a URL

      cov_k882gzrho().s[9]++;

      if (typeof soundOptions === 'string') {
        cov_k882gzrho().b[0][0]++;
        cov_k882gzrho().s[10]++;
        soundOptions = {
          src: [soundOptions]
        };
      } else {
        cov_k882gzrho().b[0][1]++;
      }

      var sprites = (cov_k882gzrho().s[11]++, soundOptions.sprite);
      cov_k882gzrho().s[12]++;

      if (isObjectWithValues(sprites)) {
        cov_k882gzrho().b[1][0]++;
        cov_k882gzrho().s[13]++;
        Object.keys(sprites).forEach(function (spriteName) {
          cov_k882gzrho().f[4]++;
          cov_k882gzrho().s[14]++;
          _this2.playing[name + spriteName] = new Set();
        });
      } else {
        cov_k882gzrho().b[1][1]++;
        cov_k882gzrho().s[15]++;
        _this2.playing[name] = new Set();
      }

      cov_k882gzrho().s[16]++;
      return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, name, new Howl(_objectSpread(_objectSpread({}, soundOptions), {}, {
        onplay: function onplay(id) {
          cov_k882gzrho().f[5]++;
          cov_k882gzrho().s[17]++;

          if (soundOptions.onplay) {
            cov_k882gzrho().b[2][0]++;
            cov_k882gzrho().s[18]++;
            soundOptions.onplay(id, dispatch);
          } else {
            cov_k882gzrho().b[2][1]++;
          }
        },
        onend: function onend(id) {
          cov_k882gzrho().f[6]++;
          cov_k882gzrho().s[19]++;

          if (soundOptions.onend) {
            cov_k882gzrho().b[3][0]++;
            cov_k882gzrho().s[20]++;
            soundOptions.onend(id, dispatch);
          } else {
            cov_k882gzrho().b[3][1]++;
          }

          cov_k882gzrho().s[21]++;

          if (!soundOptions.loop) {
            cov_k882gzrho().b[4][0]++;
            cov_k882gzrho().s[22]++;

            _this2.removeId(id);
          } else {
            cov_k882gzrho().b[4][1]++;
          }
        },
        onstop: function onstop(id) {
          cov_k882gzrho().f[7]++;
          cov_k882gzrho().s[23]++;

          if (soundOptions.onstop) {
            cov_k882gzrho().b[5][0]++;
            cov_k882gzrho().s[24]++;
            soundOptions.onstop(id, dispatch);
          } else {
            cov_k882gzrho().b[5][1]++;
          }

          cov_k882gzrho().s[25]++;

          _this2.removeId(id);
        }
      }))));
    }, {});
    cov_k882gzrho().s[26]++;
    return this.sounds;
  },
  add: function add(soundsData, dispatch) {
    var _this3 = this;

    cov_k882gzrho().f[8]++;
    cov_k882gzrho().s[27]++;

    if (!isObjectWithValues(this.sounds)) {
      cov_k882gzrho().b[6][0]++;
      cov_k882gzrho().s[28]++;
      return this.initialize(soundsData);
    } else {
      cov_k882gzrho().b[6][1]++;
    }

    var soundNames = (cov_k882gzrho().s[29]++, Object.getOwnPropertyNames(soundsData));
    cov_k882gzrho().s[30]++;
    this.sounds = soundNames.reduce(function (memo, name) {
      cov_k882gzrho().f[9]++;
      var soundOptions = (cov_k882gzrho().s[31]++, soundsData[name]); // Allow strings instead of objects, for when all that is needed is a URL

      cov_k882gzrho().s[32]++;

      if (typeof soundOptions === 'string') {
        cov_k882gzrho().b[7][0]++;
        cov_k882gzrho().s[33]++;
        soundOptions = {
          src: [soundOptions]
        };
      } else {
        cov_k882gzrho().b[7][1]++;
      }

      var sprites = (cov_k882gzrho().s[34]++, soundOptions.sprite);
      cov_k882gzrho().s[35]++;

      if (isObjectWithValues(sprites)) {
        cov_k882gzrho().b[8][0]++;
        cov_k882gzrho().s[36]++;
        Object.keys(sprites).forEach(function (spriteName) {
          cov_k882gzrho().f[10]++;
          cov_k882gzrho().s[37]++;
          _this3.playing[name + spriteName] = new Set();
        });
      } else {
        cov_k882gzrho().b[8][1]++;
        cov_k882gzrho().s[38]++;
        _this3.playing[name] = new Set();
      }

      var _ref3 = (cov_k882gzrho().s[39]++, soundOptions),
          _onplay = _ref3.onplay,
          _onstop = _ref3.onstop,
          _onend = _ref3.onend;

      var result = (cov_k882gzrho().s[40]++, _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, name, new Howl(_objectSpread(_objectSpread({}, soundOptions), {}, {
        onplay: function onplay(id) {
          cov_k882gzrho().f[11]++;
          cov_k882gzrho().s[41]++;

          if (_onplay) {
            cov_k882gzrho().b[9][0]++;
            cov_k882gzrho().s[42]++;

            _onplay(id, dispatch);
          } else {
            cov_k882gzrho().b[9][1]++;
          }
        },
        onend: function onend(id) {
          cov_k882gzrho().f[12]++;
          cov_k882gzrho().s[43]++;

          if (_onend) {
            cov_k882gzrho().b[10][0]++;
            cov_k882gzrho().s[44]++;

            _onend(id, dispatch);
          } else {
            cov_k882gzrho().b[10][1]++;
          }

          cov_k882gzrho().s[45]++;

          if (!soundOptions.loop) {
            cov_k882gzrho().b[11][0]++;
            cov_k882gzrho().s[46]++;

            _this3.removeId(id);
          } else {
            cov_k882gzrho().b[11][1]++;
          }

          cov_k882gzrho().s[47]++;

          if ((cov_k882gzrho().b[13][0]++, _this3.playlistIds) && (cov_k882gzrho().b[13][1]++, _this3.playlistIds[id])) {
            cov_k882gzrho().b[12][0]++;
            cov_k882gzrho().s[48]++;

            _this3.playlistIds[id](id);
          } else {
            cov_k882gzrho().b[12][1]++;
          }
        },
        onstop: function onstop(id) {
          cov_k882gzrho().f[13]++;
          cov_k882gzrho().s[49]++;

          if (_onstop) {
            cov_k882gzrho().b[14][0]++;
            cov_k882gzrho().s[50]++;

            _onstop(id);
          } else {
            cov_k882gzrho().b[14][1]++;
          }

          cov_k882gzrho().s[51]++;

          _this3.removeId(id);
        }
      }))))); // Delete to keep the action serializable

      cov_k882gzrho().s[52]++;
      delete soundOptions.onplay;
      cov_k882gzrho().s[53]++;
      delete soundOptions.onend;
      cov_k882gzrho().s[54]++;
      delete soundOptions.onstop;
      cov_k882gzrho().s[55]++;
      return result;
    }, this.sounds);
    cov_k882gzrho().s[56]++;
    return this.sounds;
  },
  proxy: function proxy(soundName, spriteName, name) {
    cov_k882gzrho().f[14]++;
    var sound = (cov_k882gzrho().s[57]++, this.sounds[soundName]);
    cov_k882gzrho().s[58]++;

    if (typeof sound === 'undefined') {
      cov_k882gzrho().b[15][0]++;
      cov_k882gzrho().s[59]++;
      return console.warn("\n      The sound '".concat(soundName, "' was requested, but redux-sounds doesn't have anything registered under that name.\n      See https://github.com/joshwcomeau/redux-sounds#unregistered-sound\n    "));
    } else {
      cov_k882gzrho().b[15][1]++;
    }

    cov_k882gzrho().s[60]++;

    if ((cov_k882gzrho().b[17][0]++, spriteName) && (cov_k882gzrho().b[17][1]++, typeof sound._sprite[spriteName] === 'undefined')) {
      cov_k882gzrho().b[16][0]++;
      var validSprites = (cov_k882gzrho().s[61]++, Object.keys(sound._sprite).join(', '));
      cov_k882gzrho().s[62]++;
      return console.warn("\n      The sound '".concat(soundName, "' was found, but it does not have a sprite specified for '").concat(spriteName, "'.\n      It only has access to the following sprites: ").concat(validSprites, ".\n      See https://github.com/joshwcomeau/redux-sounds#invalid-sprite\n    "));
    } else {
      cov_k882gzrho().b[16][1]++;
    }

    cov_k882gzrho().s[63]++;

    if (name === 'play') {
      cov_k882gzrho().b[18][0]++;
      cov_k882gzrho().s[64]++;
      return this.play(soundName, spriteName);
    } else {
      cov_k882gzrho().b[18][1]++;
    }

    cov_k882gzrho().s[65]++;

    for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }

    return this.howlMethod.apply(this, [soundName, spriteName, name].concat(args));
  },
  play: function play(soundName) {
    var spriteName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_k882gzrho().b[19][0]++, '');
    cov_k882gzrho().f[15]++;
    var sound = (cov_k882gzrho().s[66]++, this.sounds[soundName]);
    var id = (cov_k882gzrho().s[67]++, sound.play((cov_k882gzrho().b[20][0]++, spriteName) || (cov_k882gzrho().b[20][1]++, undefined)));
    cov_k882gzrho().s[68]++;

    if (this.playing[soundName + spriteName]) {
      cov_k882gzrho().b[21][0]++;
      cov_k882gzrho().s[69]++;
      this.playing[soundName + spriteName].add(id);
    } else {
      cov_k882gzrho().b[21][1]++;
    }

    cov_k882gzrho().s[70]++;
    return id;
  },
  playlist: function playlist(queue) {
    var _this4 = this;

    cov_k882gzrho().f[16]++;
    var playlistId = (cov_k882gzrho().s[71]++, Math.random().toString().slice(2));
    cov_k882gzrho().s[72]++;
    this.playlist[playlistId] = {
      index: 0,
      queue: queue
    };
    cov_k882gzrho().s[73]++;

    var player = function player(prevId) {
      cov_k882gzrho().f[17]++;
      cov_k882gzrho().s[74]++;
      // eslint-disable-next-line no-plusplus
      _this4.playlist[playlistId].index++;
      var nextTrack = (cov_k882gzrho().s[75]++, _this4.playlist[playlistId].queue[_this4.playlist[playlistId].index]);
      var nextId = (cov_k882gzrho().s[76]++, _this4.play(nextTrack));
      cov_k882gzrho().s[77]++;
      _this4.playlistIds[nextId] = player;
      cov_k882gzrho().s[78]++;
      delete _this4.playlistIds[prevId];
    };

    var soundId = (cov_k882gzrho().s[79]++, this.play(queue[0]));
    cov_k882gzrho().s[80]++;
    this.playlistIds[soundId] = player;
  },
  howlMethod: function howlMethod(soundName) {
    var spriteName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_k882gzrho().b[22][0]++, '');
    var method = arguments.length > 2 ? arguments[2] : undefined;

    for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      args[_key2 - 3] = arguments[_key2];
    }

    cov_k882gzrho().f[18]++;
    var sound = (cov_k882gzrho().s[81]++, this.sounds[soundName]);
    cov_k882gzrho().s[82]++;

    if (this.playing[soundName + spriteName]) {
      cov_k882gzrho().b[23][0]++;
      cov_k882gzrho().s[83]++;
      this.playing[soundName + spriteName].forEach(function (id) {
        cov_k882gzrho().f[19]++;
        cov_k882gzrho().s[84]++;
        sound[method].apply(sound, args.concat([id]));
      });
    } else {
      cov_k882gzrho().b[23][1]++;
      cov_k882gzrho().s[85]++;
      sound[method].apply(sound, args);
    }
  }
};